<div class="pagination d-flex justify-content-center align-items-center">
    <a (click)="previousClicked.emit()"><i class="fa fa-chevron-left pagination__navigation" aria-hidden="true"></i></a>
    <span class="d-flex align-items-center pagination__current-page">
        <span>Page</span>
        <input type="number" min="1" [max]="totalPages" (keydown.enter)="changePageNumber($event)" class="pagination__input" [value]="currentPageNumber" />
        <span>of {{ totalPages }}</span>
    </span>
    <a (click)="nextClicked.emit()"><i class="fa fa-chevron-right pagination__navigation" aria-hidden="true"></i></a>
</div>
